// extracted by mini-css-extract-plugin
export var halfScreenWidth = "item-module--half-screen-width--59akz";
export var item = "item-module--item--ROY4Z";
export var itemImage = "item-module--item-image--b-2Di";
export var itemImageContainer = "item-module--item-image-container--bu-ms";
export var shopButtonWrapper = "item-module--shop-button-wrapper--RHnhl";
export var soldOutBanner = "item-module--sold-out-banner--UOgLm";